import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { useRegisterMutation } from 'services/users';
import styled from 'styled-components';
import { toast } from 'react-toastify';


const RegisterPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const RegisterFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
`;

const FormTitle = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const FormField = styled.input`
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const SubmitButton = styled.button`
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const LinksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  a {
    text-decoration: none;
    color: #007bff;
  }

  a:hover {
    text-decoration: underline;
  }
`;


const RegisterPage = () => {

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation('auth');
  let navigate = useNavigate();

  const [register, { isSuccess, isError, error }] = useRegisterMutation<any>();

  useEffect(() => {
    // Update the document title using the browser API
    if(isSuccess) {
      navigate("/backoffice/", { replace: true });
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    if(isError) {
      if (error && 'data' in error && (error.data as any)?.error_description) {
        toast.error((error.data as any)?.error_description);
        setPassword('');
      } else {
        toast.error("An error occurred. Please try again later.");
      };
    }
  }, [isError]);

  const submitRegister = () => {
    if (username && password) {
      register({ username, password });
    }
  }

  return (
    <RegisterPageContainer>
      <RegisterFormContainer >
        <FormTitle>{t('register')}</FormTitle>
        <FormField type="text" placeholder={t('username')} value={username} onChange={e => setUsername(e.target.value)}/>
        <FormField type="password" placeholder={t('password')} value={password}  onChange={e => setPassword(e.target.value)}/>
        <SubmitButton type="submit" onClick={submitRegister}>{t('register')}</SubmitButton>
        <LinksContainer>
          <Link to={'/sign-up/'}>{t('sign_up')}</Link>
          <Link to={'/forgot-password/'}>{t('forgot_password')}</Link>
        </LinksContainer>
      </RegisterFormContainer>
    </RegisterPageContainer>
  );
};

export default RegisterPage;